module.exports = {"id":0,"ownerType":"business","name":"Dudley Land Co.","address":{"id":0,"addressLine1":"5925 N Robinson","city":"Oklahoma City","state":{"name":"Oklahoma","abbreviation":"OK","id":1049},"zipCode":"73118"},"contactPersonDetailsId":0,"contactPersonFirstName":"Kyle","contactPersonLastName":"Blair","email":"kyleblair@dudley-land.com"}


//////////////////
// WEBPACK FOOTER
// ./src/models/companyOwnerData.json
// module id = 1275
// module chunks = 0